module.exports = __webpack_public_path__ + "img/logo.6f0e2523.svg";